import { IItemsInventoryFilters } from '../types/itemsInventory';
import { SORTING_DIRECTION } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import { appStore } from '~/mobx/appStore';
import { PRODUCTS_SORT_COLUMN } from '~/types/product';

export const itemsInventoryNavigation = (): IScreenTab[] => [
  { path: SCREENS.PRODUCTS(), title: 'branch_items' },
  { path: SCREENS.DEAL_COMBOS(), title: 'combo_offer_tab', visible: appStore.isAddonsAvailable.deals },
  { path: SCREENS.MEAL_COMBOS(), title: 'combo_meal_tab', visible: appStore.isAddonsAvailable.meals },
];

export const defaultItemsInventoryFilters: IItemsInventoryFilters = {
  name: '',
  branch: [],
  category: undefined,
  status: undefined,
  out_of_stock: undefined,
  is_delete: 0,
  sortField: PRODUCTS_SORT_COLUMN.NAME,
  sortDir: SORTING_DIRECTION.ASCENDING,
};
